import React, { useEffect, useState } from 'react'
import { useStyles } from './PageNotFound.styles'
import { Button, Typography, Grid } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { errorLogger, type LoggerGlobalState } from '../../utils/errorLogger'

const ProductRoutingMap: Record<string, string> = {
  oppsync: 'oppsync',
  cloudfaas: 'cloudfaas',
  flyout: 'flyout',
  sales: 'labra-ai',
  funding: 'funding',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getFirstPath = (path: any) => {
  path.indexOf(1)
  path.toLowerCase()
  path = path.split('/')[1]
  return path
}

export const PageNotFound: React.FC = () => {
  const { classes } = useStyles()
  const location = useLocation()
  const product = location.pathname
  const [route, setRoute] = useState<string | null>(null)
  const globalState = useSelector((state: LoggerGlobalState) => state)
  const { search } = useLocation()
  const errorDescription = new URLSearchParams(search)
    .get('error_description')
    ?.toLowerCase()
  const tracking = new URLSearchParams(search).get('tracking')?.toLowerCase()

  useEffect(() => {
    const productSelected = getFirstPath(product)
    if (Object.values(ProductRoutingMap).includes(productSelected)) {
      setRoute(productSelected)
    } else {
      setRoute(null)
    }
  }, [product])
  useEffect(() => {
    if (errorDescription && tracking) {
      const err = { cause: errorDescription }
      errorLogger({ globalState })(err as Error, tracking)
    }
  }, [errorDescription, tracking])

  return (
    <div className={classes.root}>
      <Grid container className={classes.container} spacing={5}>
        <Grid>
          <div className={classes.content}>
            <Typography className={classes.heading} data-testid="title">
              404
            </Typography>
            <Typography className={classes.subtitle} data-testid="subtitle">
              Page Not Found
            </Typography>
            <br />
            <Typography className={classes.subtitle}>
              We are Sorry, but the page you have requested is not found
            </Typography>
            <br />
            <Button
              className={[classes.primaryButton, classes.button].join(' ')}
              variant="contained"
              onClick={() =>
                route !== null
                  ? (window.location.href = `/${route}`)
                  : (window.location.href = '/')
              }
              data-testid="button"
            >
              Go Home
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
